import Icon from '../components/Icon';

const CollWaterfalls = Icon(
  'coll-waterfalls',
  <>
    <path d="M22.29 20.57c-.36 0-.69.11-.96.29-.23-.67-.86-1.15-1.61-1.15-.95 0-1.71.77-1.71 1.71V5.13c0-.95.77-1.71 1.71-1.71h2.57a1.71 1.71 0 1 0 0-3.42H9.42C7.53 0 6 1.53 5.99 3.42v14.26c-.41-.33-.93-.53-1.49-.53-1.3 0-2.36 1.06-2.36 2.36 0 .47.14.91.38 1.28-.24-.13-.52-.21-.81-.21a1.71 1.71 0 1 0 0 3.42h20.57a1.71 1.71 0 1 0 0-3.42l.01-.01Zm-12-6.86a.86.86 0 1 1-1.72 0V4.28a.86.86 0 1 1 1.72 0v9.43Zm5.14 5.14a.86.86 0 1 1-1.72 0V9.42a.86.86 0 1 1 1.72 0v9.43Z" />
    <path d="M1.71 8.57C.76 8.57 0 9.34 0 10.28c0 2.14 3.48 2.67 4.29 4.29 0-2.14-.29-6-2.57-6h-.01ZM22.29 11.14c.95 0 1.71.77 1.71 1.71 0 2.14-3.48 2.67-4.29 4.29 0-2.14.29-6 2.57-6h.01Z" />
  </>
);

export default CollWaterfalls;
